
$(document).ready(function(){
  let accordion = [
    {
      'title':'What is DePIN?',
      'description':`<p>Decentralized Physical Infrastructure Networks (DePINs) are the bridges between the physical world and the blockchain.</p>
      <p>DePIN projects use blockchain technology, governance mechanisms, and token-based incentives to encourage autonomous actors to deploy physical hardware and devices for building infrastructural networks.</p>
      <p>Put it simply: The idea is running infrastructure with blockchains.</p>`
    },
    {
      'title':'Who uses DePIN',
      'description':`<p>The primary consumers of DePIN projects are users that heavily invest in constructing and managing physical infrastructures, like telecommunication companies. </p>
      <p>DePIN utilizes blockchain and tokenization to provide these users with a decentralized, more efficient, and cost-effective way to manage their physical infrastructure, compared to traditional centralized systems.</p>`
    },
    {
      'title':'What are the advantages of DePIN?',
      'description':`<p>By adopting DePIN, users can potentially reduce the time, energy, and resources required for infrastructure development, while benefiting from a more resilient and community-driven solution.</p>`
    },
    {
      'title':'What are the projects in the DePIN space?',
      'description':`<p>The Helium Network is one of the earliest use cases DePIN: members get rewarded with crypto ($IOT and $MOBILE) tokens for deploying Helium Hotspots and providing wireless network coverage. Helium is the world’s largest decentralized wireless network.</p>
      <p>Most recently,  launched  Energy Gateways integrate with your solar panels and batteries, connecting you to a vast network where each contribution strengthens a collective energy solution. This is your gateway to participating directly in a DePIN virtual power plant.</p>`
    },
    {
      'title':'Why Helium?',
      'description':`
      <b>Anyone can help build</b>
      <p>All you need is to install a simple "Hotspot" in your home, business, or in the wild to join</p>
      <br>
      <br>

      <b>Anyone can use and connect to the network</b>
      <p>All kinds of devices can connect to it - like sensors that track the weather, trackers that find lost pets, or even your own phone</p>
      <br>
      <br>
      <b>Get rewarded with Helium tokens</b>
      <p>You can earn $IOT and $MOBILE for helping build something awesome</p>
      <br>
      <br>

      <b>Helping build The People’s Network is easy!</b>
      <p>
        <ul>
          <li>> Choose your hardware</li>
          <li>> Deploy in minutes</li>
          <li>> Earn Helium tokens ($IOT and $MOBILE)</li>
        </ul>
      </p>
      `
    }
  ]

  let accordion_html = ''

  accordion.map(a=>{
    accordion_html+=`
      <div class="accordion__container">
        <div class="accordion">
          <h3>${a.title}</h3>
          <img src="https://cdn.shopify.com/s/files/1/0177/8784/6756/files/accordion.svg?v=1723128392" class="arrow"/>
        </div>
        <div class="panel">
          ${a.description}
        </div>
      </div>
    `
  })

  $('.depin .accordions').html(accordion_html)

  
  $('.depin .accordion').on('click',function(){
    $(this).next().toggle()
    if($(this).next().is(":visible"))
      $(this).find('.arrow').css('transform' , 'rotate(0deg)');
    else
      $(this).find('.arrow').css('transform' , 'rotate(180deg)');
  })

  let featured_projects = [
    {
      'img':'https://cdn.shopify.com/s/files/1/0177/8784/6756/files/2mobile.png?v=1730270454',
      'title':'MOBILE',
      'description':`
      <p>Earn $MOBILE tokens for helping build the Helium Network, a new network owned and operated by people</p>
      <p>MNTD. is the first third-party MOBILE Hotspot vendor on the Helium Network.</p>`
    },
    {
      'img':'https://cdn.shopify.com/s/files/1/0177/8784/6756/files/iot.png?v=1730270454',
      'title':'IOT',
      'description':`
      <p>Earn $IOT tokens for building the Helium IOT Network</p>
      <p>RAKwireless is the same company that created the original hotspots for Helium and has deployed the largest number of Hotspots to date.</p>
      `
    }

  ]
  let featured_html = ''
  featured_projects.map(f=>{
    featured_html += `
    <a href="#" class="card">
      <div><img src="${f.img}"/></div>
      <div class="card__title">${f.title}</div>
      <div class="card__description">
        ${f.description}
      </div>
    </a>
    `
  })

  $('.depin .cards').html(featured_html)


})